import Constants from "common/Constants";

import _, { isEqual } from "lodash";
import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";

const useMemberShip = () => {
    const { pedcCd } = useSelector((state) => state.loginReducer);
    const { isAlltabMember } = useSelector((state) => state.commonReducer); // 올탭 화상과외 멤버 여부

    const MEMBERSHIP_LIST = Constants?.MEMBERSHIP_LIST ?? {
        LTAL: "",
        ALTB: {
            ENGM: "",
            MATH: "",
            SCNE: "",
        },
    }; // 이용권 목록

    const MEMBER_SHIP_NAME = {
        LTAL: "LTAL",
        LTAL_ALTB: "LTAL_ALTB",
        ALTB: "ALTB",
        SMAL: "SMAL",
    }; // 이용권 명

    const getPedcCode = useCallback(() => pedcCd || null, [pedcCd]);
    const getMemberShip = useCallback(() => {
        const { LTAL, ALTB } = MEMBERSHIP_LIST;

        let memberShip = null;
        const pedcCd = getPedcCode();

        /* [TEST] 테스트용 코드 START */

        // memberShip = MEMBER_SHIP_NAME.LTAL;
        // memberShip = MEMBER_SHIP_NAME.LTAL_ALTB;
        // memberShip = MEMBER_SHIP_NAME.ALTB;
        // memberShip = MEMBER_SHIP_NAME.SMAL;

        // return memberShip;

        /* [TEST] 테스트용 코드 END */

        if (isEqual(pedcCd, LTAL) && !isAlltabMember) {
            // 국사과 라이트 + 올탭과외 X
            memberShip = MEMBER_SHIP_NAME.LTAL;
        } else if (isEqual(pedcCd, LTAL) && isAlltabMember) {
            // 국사과 라이트 + 올탭과외 O
            memberShip = MEMBER_SHIP_NAME.LTAL_ALTB;
        } else if (Object.values(ALTB).includes(pedcCd)) {
            // 올탭 단과목
            memberShip = MEMBER_SHIP_NAME.ALTB;
        } else if (isAlltabMember) {
            // 종합물(=스마트올(모)) + 올탭과외
            memberShip = MEMBER_SHIP_NAME.SMAL;
        }

        return memberShip;
    }, [getPedcCode, MEMBERSHIP_LIST, MEMBER_SHIP_NAME, isAlltabMember]);

    const ckLTAL = useCallback(() => {
        return isEqual(getMemberShip(), MEMBER_SHIP_NAME.LTAL) || false;
    }, [getMemberShip, MEMBER_SHIP_NAME]);

    const ckLTAL_ALTB = useCallback(() => {
        return isEqual(getMemberShip(), MEMBER_SHIP_NAME.LTAL_ALTB) || false;
    }, [getMemberShip, MEMBER_SHIP_NAME]);

    const ckALTB = useCallback(() => {
        return isEqual(getMemberShip(), MEMBER_SHIP_NAME.ALTB) || false;
    }, [getMemberShip, MEMBER_SHIP_NAME]);

    const ckSMAL = useCallback(() => {
        return isEqual(getMemberShip(), MEMBER_SHIP_NAME.SMAL) || false;
    }, [getMemberShip, MEMBER_SHIP_NAME]);

    // useEffect(() => {
    //     if (String(process.env.REACT_APP_ENV).trim() === "real") return;

    //     if (pedcCd) {
    //         const memberShip = getMemberShip();
    //         if (memberShip) {
    //             console.log("%c ### 멤버쉽이용권 이름 :: ", "color: dodgerblue; font-weight: bold;", memberShip);
    //         }
    //     }
    // }, [pedcCd, isAlltabMember, getMemberShip]);

    return {
        ckLTAL, // 국사과 라이트
        ckLTAL_ALTB, // 국사과 라이트 + 올탭과외
        ckALTB, // 올탭 단과목
        ckSMAL, // 종합물(=스마트올(모)) + 올탭과외
    };
};

export default useMemberShip;
